import React from "react";
import Event from "../../events/types/Event";
import City from "../../cities/types/City";
import EventCity from "../../eventCities/types/EventCity";
import useTranslate from "../../core/languages/hooks/useTranslate";
import useCustomerContext from "../../customers/hooks/useCustomerContext";

const TransferCard: React.FC<{ eventInfo: Event; cityInfo: City; cityEventInfo: EventCity }> = ({eventInfo, cityInfo, cityEventInfo}) => {
    const t = useTranslate();
    const { languageCode } = useCustomerContext();

    return (
        <div className="p-6 bg-blue-50 dark:bg-blue-900/30 rounded-2xl border border-blue-100 dark:border-blue-800">
            <h5 className="text-lg font-semibold mb-2 text-blue-900 dark:text-blue-100">
                {t('transfers.message.formTitle')} — {`${eventInfo?.initials} ${cityInfo?.trName[languageCode]}`}
            </h5>
            <p className="text-sm text-blue-800 dark:text-blue-200 mb-4">
                {t("bookOk.transferServiceDescription")}
            </p>
            <a
                href={cityEventInfo?.transfer}
                rel="noopener noreferrer"
                className="ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50 px-4 py-3 sm:px-6 text-sm sm:text-base font-medium nc-Button relative h-auto inline-flex items-center justify-center rounded-full transition-colors"
            >
                {t("bookOk.bookTransfer")}
            </a>
        </div>
    );
};

export default TransferCard;
